export default "__VITE_ASSET__CodjjakF__"